function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ResponsiveBanner from "template-store/components/banner/responsive-banner/responsive-banner";
import { StyledBanner } from "./banner.scss";
const DESKTOP_BANNER_PLACEHOLDER_LINK = "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/mondayhomepage/template-store/banners-images/main_banner_image-no-padding.png";
const MOBILE_BANNER_PLACEHOLDER_LINK = "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/mondayhomepage/template-store/banners-images/mobile_banner.png";
const Banner = (props)=>{
    return /*#__PURE__*/ _jsxs(StyledBanner, {
        className: "banner-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "desktop-wrapper",
                children: /*#__PURE__*/ _jsx(ResponsiveBanner, _object_spread({
                    imageLink: DESKTOP_BANNER_PLACEHOLDER_LINK
                }, props))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mobile-wrapper",
                children: /*#__PURE__*/ _jsx(ResponsiveBanner, _object_spread({
                    isMobileBanner: true,
                    imageLink: MOBILE_BANNER_PLACEHOLDER_LINK
                }, props))
            })
        ]
    });
};
export default Banner;
